(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core"], factory);
	else if(typeof exports === 'object')
		exports["widget-metro-analytics"] = factory(require("base"), require("core"));
	else
		root["widget-metro-analytics"] = factory(root["base"], root["core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	/**
	 *  ----------------------------------------------------------------
	 *  Copyright © Backbase B.V.
	 *  ----------------------------------------------------------------
	 *  Author : Backbase R&D - Amsterdam - New York
	 *  Filename : main.js
	 *  Description: ${widget.description}
	 *  ----------------------------------------------------------------
	 */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    (function (i, s, o, g, r, a, m) {
	        i['GoogleAnalyticsObject'] = r;
	        i[r] = i[r] || function () {
	            (i[r].q = i[r].q || []).push(arguments);
	        };
	        i[r].l = 1 * new Date();
	        a = s.createElement(o);
	        m = s.getElementsByTagName(o)[0];
	        a.async = 1;
	        a.src = g;
	        m.parentNode.append(a, m);
	    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);

	    var deps = [core.name];
	    module.name = 'met-accounts-analytics';

	    // @ngInject
	    var run = function run(lpWidget) {
	        var account = lpWidget.getPreference('gaAccount');

	        window.ga('create', account, 'auto');
	        window.ga('send', 'pageview');

	        if ($('body.designMode').length) {
	            $(lpWidget.body).text('Google Analytics account: ' + account);
	        }
	    };

	    module.exports = base.createModule(module.name, deps).run(run);

	    var url = window.location.pathname;
	    window.gadgets.pubsub.subscribe('ga', function () {
	        // prevent duplicates
	        window.setTimeout(function () {
	            if (url !== window.location.pathname) {
	                url = window.location.pathname;
	                window.ga('send', 'pageview', url);
	            }
	        }, 100);
	    });
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js